import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import { isStorefrontNext } from "helpers/environment-helpers";

class FilterFieldsetHeader extends React.Component {
  static minimizableClass = "minimizable";

  isMinimizable = () => {
    return _.isUndefined(this.props.isMinimizable) || this.props.isMinimizable;
  };

  renderOptionalIcon = () => {
    if (this.props.iconClass) {
      return <span className={this.props.iconClass}></span>;
    }
  };

  renderSummaryClasses = () => {
    var minimizableClass = "";

    if (this.isMinimizable()) {
      minimizableClass = this.constructor.minimizableClass;
    }

    return "filter-fieldset-header__title " + minimizableClass;
  };

  renderSummaryCount = () => {
    const { count } = this.props;
    if (count && isStorefrontNext()) {
      return <span className="filter-fieldset-header__count">{count}</span>;
    }
    return false;
  };

  render() {
    return (
      <div className="filter-fieldset-header" onClick={this.props.onClick}>
        <div className={this.renderSummaryClasses()}>
          <span>
            {this.props.title}
            {this.renderSummaryCount()}
          </span>
          {this.renderOptionalIcon()}
        </div>
      </div>
    );
  }
}

FilterFieldsetHeader.propTypes = {
  title: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
  isMinimizable: PropTypes.bool,
  onClick: PropTypes.func,
  count: PropTypes.number,
};

export default FilterFieldsetHeader;
